/**
 * Created by wanglimin on 2017/4/25.
 */

import config from './config-faq';

var tools = {
    decodeJavaBase64InBrowser: function (javaBase64String) {
        try {
            // 输入验证
            if (typeof javaBase64String !== 'string') {
                throw new Error('输入必须是字符串类型');
            }

            if (!javaBase64String.trim()) {
                throw new Error('输入字符串不能为空');
            }

            // Java Base64 通常使用标准编码，但可能需要处理换行和特殊字符
            let base64String = javaBase64String
                .replace(/\s/g, '')       // 移除所有空白字符
                .replace(/-/g, '+')       // 处理 URL 安全的 Base64
                .replace(/_/g, '/');      // 处理 URL 安全的 Base64

            // 补全 Base64 填充字符（=）
            const padLength = base64String.length % 4;
            if (padLength > 0) {
                base64String += '='.repeat(4 - padLength);
            }

            // 解码 Base64
            let decodedString;
            try {
                decodedString = atob(base64String);
            } catch (e) {
                throw new Error('Base64 解码失败，输入可能不是有效的 Base64 字符串');
            }

            // 验证解码结果
            if (!decodedString) {
                throw new Error('解码结果为空');
            }

            // 验证是否是有效的 URL（可选）
            try {
                new URL(decodedString); // 如果解码结果不是 URL 会抛出错误
            } catch (e) {
                console.warn('解码结果不是有效的 URL，但已返回原始字符串');
            }

            return decodedString;
        } catch (error) {
            // 增强错误信息
            console.error('Base64 解码过程中发生错误:', error);
            throw new Error(`无法解码 Base64 字符串: ${error.message}`);
        }
    },

    getUrlString: function(url){
        var urlString = url.split('?');
        var queryArr = [];
        var queryObj = {};

        if(urlString.length === 2){
            queryArr = urlString[1].split('&');

            for(var i = 0; i < queryArr.length; i++){
                var qa = queryArr[i].split('=');
                queryObj[qa[0]] = qa[1];
            }
        }

        return queryObj;
    },

    addEvt: function(o, e, fn){
        if(o.addEventListener){
            o.addEventListener(e, fn);
        }else if(o.attachEvent){
            o.attachEvent('on' + e, fn);
        }else{
            return false;
        }
    },

    addClass: function(el, cln){
        let cnArr = el.className.split(' ');
        let classn = '';
        var hasClass = false;

        if(tools.hasClass(el, cln)){
            classn = cnArr.join(' ');
        }else{
            cnArr.push(cln);
            if(cnArr[0] === ''){
                cnArr.splice(0, 1);
            }
            classn = cnArr.join(' ');
        }
        el.className = classn;
    },

    hasClass: function(el, cln){
        let cnArr = el.className.split(' ');
        var hasClass = false;

        for(var i = 0; i < cnArr.length; i++){
            if(cnArr[i] === cln){
                hasClass = true;
            }
        }

        return hasClass;
    },

    removeClass: function(el, cln){
        let cnArr = el.className.split(' ');
        let classn = '';

        for(var i = 0; i < cnArr.length; i++){
            if(cnArr[i] === cln){
                cnArr.splice(i, 1)
                classn =  cnArr.join(' ');
            }else{
                classn = cnArr.join(' ');
            }
        }

        el.className = classn;
    },

    parseQueryString: function (url) {
		var reg_url = /^[^\?]+\?([\w\W]+)$/;
		var reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g;
		var arr_url = reg_url.exec(url);
		var ret = {};
			  
		if (arr_url && arr_url[1]) {
			var str_para = arr_url[1], result;
	  
			while ((result = reg_para.exec(str_para)) != null) {
				ret[result[1]] = result[2];
			}
		}
		return ret;
	},

    getLocaleLang: function(keys){
        var localeLang = typeof navigator === 'undefined' ? config.defaultLang : (navigator.language || navigator.userLanguage || config.defaultLang);
		var localeArr = localeLang.split('-');
        var lang = '';
        var langArr = [];
        var language = this.parseQueryString(window.location.href)['lang'] || '';       // 链接中的 lang 参数

        // 匹配, 配置文件中的语言
        var checkExsit = function(la){
            var l = (la || config.defaultLang).toLowerCase();

            if(l == 'bh' || l == 'ha' || l == 'ra'){
                l = 'hi';
            }

            for(var i = 0; i < langArr.length; i++){
                if(langArr[i] == l){
                    lang = langArr[i];
                    return true;
                }
            }

            return false;
        }

        if(keys){
            langArr = keys;
        }else{
            langArr = config.defaultLang;
        }

        if(language){
            return checkExsit(language) ? lang : config.defaultLang;
        }else{
            return checkExsit(localeArr[0]) ? lang :  config.defaultLang;
        }
	},

    getJson: function(opts){
        var options = {
            async: true,
            url: '',
            method: "GET",
            data: {},
            success: function(){},
            error: function(){}
        };

        for(var i in opts){
            options[i] = opts[i];
        }

        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open(options.method, options.url, options.async);
        xmlhttp.onreadystatechange = function(){
            if(xmlhttp.readyState == 4 && xmlhttp.status == 200){
                options.success(xmlhttp.responseText);
            }
            
            if(xmlhttp.status == 400 || (xmlhttp.status == 0 && !xmlhttp.responseText)){
                options.error();
            }
        }
        xmlhttp.send(null);
    },

    // min < r < max 
    RandomNum: function(Min, Max) {
        var Range = Max - Min;
        var Rand = Math.random();
        if(Math.round(Rand * Range)==0){
          return Min + 1;
        }else if(Math.round(Rand * Max)==Max){
          return Max - 1;
        }else{
          var num = Min + Math.round(Rand * Range) - 1;
          return num;
        }
   }
};

export default tools;


// WEBPACK FOOTER //
// ./src/assets/js/tools-qureka.js